import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import API from "./config/API";

function UserCompleteBookingForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const bedData = location.state || {};

  // ============================================================
  // LOGGED USER
  // ============================================================

  const loggedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const pgName = loggedUser?.pgName || localStorage.getItem("pgName") || "";

  const emailId = loggedUser?.emailId || localStorage.getItem("emailId") || "";

  console.log("Logged User & pgName:", pgName, loggedUser);

  const today = new Date().toISOString().split("T")[0];

  // ============================================================
  // STATES
  // ============================================================

  const [submitting, setSubmitting] = useState(false);

  // OTP
  const [otpPopup, setOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpSending, setOtpSending] = useState(false);

  // Booking custom ID
  const [customId, setCustomId] = useState(null);

  // Existing user
  const [checkingUser, setCheckingUser] = useState(false);
  const [existingUserFound, setExistingUserFound] = useState(false);
  const [userSearchMessage, setUserSearchMessage] = useState("");
  const [existingUserStoreId, setExistingUserStoreId] = useState(null);

  // Popup
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "",
  });

  // ============================================================
  // POPUP
  // ============================================================

  const showPopup = (message, type) => {
    setPopup({
      show: true,
      message,
      type,
    });

    setTimeout(() => {
      setPopup({
        show: false,
        message: "",
        type: "",
      });
    }, 2000);
  };

  // ============================================================
  // BED DETAILS
  // ============================================================

  const bedDetails = {
    userFloorId: bedData.floorId,
    userFloorName: bedData.floorName,
    userRoomId: bedData.roomId,
    userRoomName: bedData.roomName,
    userBedId: bedData.bedId,
    userBedName: bedData.bedName,
    bedCost: bedData.bedCost,
    bedCostPerDay: bedData.bedCostPerDay,
    offerPrice: bedData.inOfferPrice_bedCost,
    isSnoringroom: bedData.isSnoringroom,
  };

  // ============================================================
  // USER FORM
  // ============================================================

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    contactNo: "",
    alternativeContactNo: "",
    emailId: "",
    pgName: pgName,
    aadharCardNo: "",
    gender: "",
    userDateOfBirth: "",
    userjoiningDate: "",
  });

  const [errors, setErrors] = useState({});

  // ============================================================
  // EMAIL VALIDATION
  // ============================================================

  const isValidEmail = (email) => /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(email);

  // ============================================================
  // DOB VALIDATION
  // ============================================================

  const isValidDOB = (dob) => {
    if (!/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/.test(dob)) {
      return false;
    }

    const [dd, mm, yyyy] = dob.split("-").map(Number);

    const date = new Date(yyyy, mm - 1, dd);
    const current = new Date();

    if (
      date.getDate() !== dd ||
      date.getMonth() !== mm - 1 ||
      date.getFullYear() !== yyyy
    ) {
      return false;
    }

    return date < current;
  };

  // ============================================================
  // CHECK USER BY CONTACT NUMBER
  // ============================================================

  const checkUserByContact = async (contactNumber) => {
    if (!contactNumber || contactNumber.length !== 10) {
      setExistingUserFound(false);
      setExistingUserStoreId(null);
      setUserSearchMessage("");
      return;
    }

    try {
      setCheckingUser(true);
      setUserSearchMessage("");
      setExistingUserFound(false);
      setExistingUserStoreId(null);

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const response = await axios.get(`${API.V1}/pgOwner/checkUserExists`, {
        params: {
          contactNo: contactNumber,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.jwtToken}`,
        },
      });

      console.log("Check User Response:", response.data);

      // ========================================================
      // EXISTING USER
      // ========================================================

      if (response.data?.statusCode === 200 && response.data?.data) {
        const existingUser = response.data.data;

        console.log("Existing User:", existingUser);

        setExistingUserFound(true);

        setExistingUserStoreId(existingUser.userStoreId || null);

        // ------------------------------------------------------
        // AUTO FILL FORM
        // ------------------------------------------------------

        setForm((prev) => ({
          ...prev,

          firstName: existingUser.firstName || "",

          lastName: existingUser.lastName || "",

          contactNo: existingUser.contactNo
            ? String(existingUser.contactNo)
            : contactNumber,

          alternativeContactNo: existingUser.alternativeContactNo
            ? String(existingUser.alternativeContactNo)
            : "",

          emailId: existingUser.emailId || "",

          pgName: existingUser.lastStayingPgName || prev.pgName || "",

          aadharCardNo: existingUser.aadharCardNo
            ? String(existingUser.aadharCardNo)
                .replace(/\s/g, "")
                .replace(/(\d{4})(?=\d)/g, "$1 ")
                .trim()
            : "",

          gender: existingUser.gender || "",

          userDateOfBirth: existingUser.userDateOfBirth || "",

          userjoiningDate: existingUser.userBedJoingingDate || "",
        }));

        setUserSearchMessage(
          `Existing user found. Details filled automatically.`,
        );
      } else {
        // ======================================================
        // NEW USER
        // ======================================================

        setExistingUserFound(false);
        setExistingUserStoreId(null);

        setUserSearchMessage(
          "New user. Please enter registration details manually.",
        );

        // Keep contact number
        setForm((prev) => ({
          ...prev,
          contactNo: contactNumber,
        }));
      }
    } catch (error) {
      console.error("Check User Error:", error);

      setExistingUserFound(false);
      setExistingUserStoreId(null);

      setUserSearchMessage(
        "Unable to check existing user. Please enter details manually.",
      );

      setForm((prev) => ({
        ...prev,
        contactNo: contactNumber,
      }));
    } finally {
      setCheckingUser(false);
    }
  };

  // ============================================================
  // HANDLE CHANGE
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // ==========================================================
    // CONTACT NUMBERS
    // ==========================================================

    if (name === "contactNo" || name === "alternativeContactNo") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    // ==========================================================
    // AADHAAR
    // ==========================================================

    if (name === "aadharCardNo") {
      const digits = value.replace(/\D/g, "").slice(0, 12);

      updatedValue = digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
    }

    // ==========================================================
    // DOB
    // ==========================================================

    if (name === "userDateOfBirth") {
      let digits = value.replace(/\D/g, "");

      if (digits.length > 2 && digits.length <= 4) {
        digits = digits.slice(0, 2) + "-" + digits.slice(2);
      } else if (digits.length > 4) {
        digits =
          digits.slice(0, 2) +
          "-" +
          digits.slice(2, 4) +
          "-" +
          digits.slice(4, 8);
      }

      updatedValue = digits;
    }

    // ==========================================================
    // UPDATE FORM
    // ==========================================================

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // Clear validation error
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // ==========================================================
    // CONTACT NUMBER USER SEARCH
    // ==========================================================

    if (name === "contactNo") {
      if (updatedValue.length === 10) {
        checkUserByContact(updatedValue);
      } else {
        setExistingUserFound(false);
        setExistingUserStoreId(null);
        setUserSearchMessage("");
      }
    }
  };

  // ============================================================
  // RESEND OTP
  // ============================================================

  const resendBookingOtp = async () => {
    if (!customId) {
      showPopup(
        "Booking ID not found. Please complete the booking again.",
        "error",
      );
      return;
    }

    try {
      setOtpSending(true);
      setOtpError("");

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const res = await axios.post(
        `${API.V2}/pgOwner/resendBookingOtp`,
        {
          customId: customId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data?.statusCode === 200) {
        showPopup(res.data?.message || "OTP resent successfully.", "success");
      } else {
        showPopup(res.data?.message || "Unable to resend OTP.", "error");
      }
    } catch (error) {
      console.error("OTP Resend Error:", error);

      showPopup(
        error.response?.data?.message || "Failed to resend OTP.",
        "error",
      );
    } finally {
      setOtpSending(false);
    }
  };

  // ============================================================
  // VERIFY OTP
  // ============================================================

  const verifyBookingOtp = async () => {
    if (!otp.trim()) {
      setOtpError("Please enter OTP");
      return;
    }

    if (!/^\d{6}$/.test(otp)) {
      setOtpError("OTP must be 6 digits");
      return;
    }

    if (!customId) {
      setOtpError("Booking ID not found. Please complete the booking again.");
      return;
    }

    try {
      setOtpLoading(true);
      setOtpError("");

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const payload = {
        customId: customId,
        otp: otp,
      };

      console.log("Verify Booking OTP Payload:", payload);

      const res = await axios.post(
        `${API.V2}/pgOwner/verifyBookingOtp`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      console.log("Verify Booking OTP Response:", res.data);

      if (res.data?.statusCode === 200) {
        setOtpPopup(false);
        setOtp("");
        setOtpError("");

        showPopup(res.data?.message || "OTP verified successfully.", "success");

        const bookingId = res.data?.customId || customId;

        sessionStorage.setItem("userBookingId", bookingId);

        setTimeout(() => {
          navigate("/userPaymentForm1", {
            state: {
              emailId: form.emailId,
              userBookingId: bookingId,
              userBedJoiningDate: form.userjoiningDate,

              // This is userRegisterId returned
              // by backend, NOT userStoreId.
              registerId: res.data?.registerId || null,
            },
          });
        }, 1000);
      } else {
        setOtpError(res.data?.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);

      setOtpError(error.response?.data?.message || "Invalid or expired OTP.");
    } finally {
      setOtpLoading(false);
    }
  };

  // ============================================================
  // SUBMIT BOOKING
  // ============================================================

  const handleSubmit = async () => {
    let tempErrors = {};

    // ==========================================================
    // FIRST NAME
    // ==========================================================

    if (!form.firstName.trim()) {
      tempErrors.firstName = "First Name is required";
    }

    // ==========================================================
    // LAST NAME
    // ==========================================================

    if (!form.lastName.trim()) {
      tempErrors.lastName = "Last Name is required";
    }

    // ==========================================================
    // CONTACT
    // ==========================================================

    if (form.contactNo.length !== 10) {
      tempErrors.contactNo = "Contact Number must be 10 digits";
    }

    // ==========================================================
    // ALTERNATIVE CONTACT
    // ==========================================================

    if (form.alternativeContactNo.length !== 10) {
      tempErrors.alternativeContactNo =
        "Alternative Contact Number must be 10 digits";
    }

    // ==========================================================
    // EMAIL
    // ==========================================================

    if (!isValidEmail(form.emailId)) {
      tempErrors.emailId = "Enter valid Gmail address";
    }

    // ==========================================================
    // AADHAAR
    // ==========================================================

    if (form.aadharCardNo.replace(/\s/g, "").length !== 12) {
      tempErrors.aadharCardNo = "Aadhaar Number must be 12 digits";
    }

    // ==========================================================
    // DOB
    // ==========================================================

    if (!isValidDOB(form.userDateOfBirth)) {
      tempErrors.userDateOfBirth = "Enter valid DOB (DD-MM-YYYY)";
    }

    // ==========================================================
    // GENDER
    // ==========================================================

    if (!form.gender) {
      tempErrors.gender = "Select Gender";
    }

    // ==========================================================
    // JOINING DATE
    // ==========================================================

    if (!form.userjoiningDate) {
      tempErrors.userjoiningDate = "Joining Date is required";
    } else if (form.userjoiningDate < today) {
      tempErrors.userjoiningDate = "Joining Date cannot be earlier than today";
    }

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      return;
    }

    // ==========================================================
    // FINAL PAYLOAD
    // ==========================================================

    const payload = {
      bedDetails: {
        /*
         * Do not use existingUserStoreId here.
         *
         * userStoreId and userRegisterId are
         * different IDs.
         *
         * Backend will create/get the appropriate
         * userRegisterId.
         */
        userRegisterId: 1,

        userFloorId: bedDetails.userFloorId,

        userFloorName: bedDetails.userFloorName,

        userRoomId: bedDetails.userRoomId,

        userRoomName: bedDetails.userRoomName,

        userBedId: bedDetails.userBedId,

        userBedName: bedDetails.userBedName,

        bedStatus: "BOOKED",

        snoringHabbit: bedDetails.isSnoringroom ? "Yes" : "No",

        userCreatedBy: emailId,

        gender: form.gender,

        firstName: form.firstName,

        lastName: form.lastName,

        contactNo: form.contactNo,

        alternativeContactNo: form.alternativeContactNo,

        emailId: form.emailId,

        aadharCardNo: form.aadharCardNo,

        userDateOfBirth: form.userDateOfBirth,

        userjoiningDate: form.userjoiningDate,
      },
    };

    console.log("Existing User Store ID:", existingUserStoreId);

    console.log("Booking Payload:", payload);

    // ==========================================================
    // API CALL
    // ==========================================================

    try {
      setSubmitting(true);

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const res = await axios.post(
        `${API.V2}/pgOwner/userCompleteBedRegister`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      console.log("Complete Bed Register Response:", res.data);

      // ========================================================
      // SUCCESS
      // ========================================================

      if (res.data?.statusCode === 200) {
        const returnedCustomId = res.data?.customId;

        if (!returnedCustomId) {
          showPopup("OTP sent, but booking ID was not returned.", "error");
          return;
        }

        setCustomId(returnedCustomId);

        sessionStorage.setItem("userBookingId", returnedCustomId);

        setOtp("");
        setOtpError("");

        setOtpPopup(true);

        showPopup(res.data?.message || "OTP sent successfully.", "success");
      }

      // ========================================================
      // BAD REQUEST
      // ========================================================
      else if (res.data?.statusCode === 400) {
        showPopup(res.data?.message || "Booking failed.", "error");
      }

      // ========================================================
      // OTHER RESPONSE
      // ========================================================
      else {
        showPopup(res.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Complete Booking Error:", error);

      // ========================================================
      // UNAUTHORIZED
      // ========================================================

      if (error.response?.status === 401) {
        showPopup("Session Expired. Please login again.", "error");

        localStorage.clear();

        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        showPopup(error.response?.data?.message || "Server Error", "error");
      }
    } finally {
      setSubmitting(false);
    }
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* ====================================================
                         OTP POPUP
        ==================================================== */}

        {otpPopup && (
          <div style={styles.otpOverlay}>
            <div style={styles.otpBox}>
              <div style={styles.otpIcon}>🔐</div>

              <h2 style={styles.otpTitle}>Verify Your Booking</h2>

              <p style={styles.otpText}>
                We have sent a 6-digit OTP to
                <br />
                <strong>{form.emailId}</strong>
                <br />
                <span
                  style={{
                    fontSize: "13px",
                    color: "#64748b",
                  }}
                >
                  Please enter the OTP to continue your booking.
                </span>
              </p>

              {/* OTP INPUT */}

              <input
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={otp}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);

                  setOtp(value);
                  setOtpError("");
                }}
                placeholder="Enter 6-digit OTP"
                maxLength={6}
                style={styles.otpInput}
                autoFocus
              />

              {otpError && <p style={styles.otpError}>{otpError}</p>}

              {/* VERIFY */}

              <button
                type="button"
                onClick={verifyBookingOtp}
                disabled={otpLoading || otp.length !== 6}
                style={{
                  ...styles.verifyOtpButton,

                  ...(otpLoading || otp.length !== 6
                    ? styles.verifyOtpButtonDisabled
                    : {}),
                }}
              >
                {otpLoading ? "Verifying..." : "Verify OTP"}
              </button>

              {/* RESEND */}

              <button
                type="button"
                onClick={resendBookingOtp}
                disabled={otpSending}
                style={styles.resendButton}
              >
                {otpSending ? "Sending..." : "Resend OTP"}
              </button>

              {/* CANCEL */}

              <button
                type="button"
                onClick={() => {
                  if (!otpLoading) {
                    setOtpPopup(false);
                    setOtp("");
                    setOtpError("");
                  }
                }}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* ====================================================
                    SUCCESS / ERROR POPUP
        ==================================================== */}

        {popup.show && (
          <div
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              padding: "15px 22px",
              borderRadius: 10,
              color: "#fff",
              fontWeight: "700",
              zIndex: 100000,
              background: popup.type === "success" ? "#16a34a" : "#dc2626",
              boxShadow: "0 10px 25px rgba(0,0,0,.25)",
            }}
          >
            {popup.message}
          </div>
        )}

        {/* ====================================================
                         PAGE TITLE
        ==================================================== */}

        <h1 style={styles.title}>🏠 Complete Bed Booking</h1>

        {/* ====================================================
                         BED DETAILS
        ==================================================== */}

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>🛏 Bed Details</h2>

          <div style={styles.grid}>
            <div style={styles.cardBlue}>
              <label style={styles.label}>Floor Name</label>

              <input
                readOnly
                value={bedDetails.userFloorName || ""}
                style={styles.input}
              />
            </div>

            <div style={styles.cardGreen}>
              <label style={styles.label}>Room Name</label>

              <input
                readOnly
                value={bedDetails.userRoomName || ""}
                style={styles.input}
              />
            </div>

            <div style={styles.cardPurple}>
              <label style={styles.label}>Bed Name</label>

              <input
                readOnly
                value={bedDetails.userBedName || ""}
                style={styles.input}
              />
            </div>

            <div style={styles.cardOrange}>
              <label style={styles.label}>Monthly Bed Rent</label>

              {bedDetails.offerPrice > 0 ? (
                <>
                  <div style={styles.oldPrice}>₹ {bedDetails.bedCost}</div>

                  <input
                    readOnly
                    value={`₹ ${bedDetails.offerPrice}`}
                    style={styles.offerInput}
                  />
                </>
              ) : (
                <input
                  readOnly
                  value={`₹ ${bedDetails.bedCost || ""}`}
                  style={styles.input}
                />
              )}
            </div>

            <div style={styles.cardSky}>
              <label style={styles.label}>Per Day Rent</label>

              <input
                readOnly
                value={
                  bedDetails.bedCostPerDay
                    ? `₹ ${bedDetails.bedCostPerDay}`
                    : "Not Available"
                }
                style={styles.input}
              />
            </div>

            <div style={styles.cardPink}>
              <label style={styles.label}>Snoring Room</label>

              <input
                readOnly
                value={bedDetails.isSnoringroom ? "Yes" : "No"}
                style={styles.input}
              />
            </div>
          </div>
        </div>

        {/* ====================================================
                    USER REGISTRATION DETAILS
        ==================================================== */}

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>👤 User Registration Details</h2>

          <div style={styles.grid}>
            {/* FIRST NAME */}

            <div style={styles.cardBlue}>
              <label style={styles.label}>First Name</label>

              <input
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                placeholder="Enter First Name"
                style={styles.input}
              />

              {errors.firstName && (
                <p style={styles.error}>{errors.firstName}</p>
              )}
            </div>

            {/* LAST NAME */}

            <div style={styles.cardGreen}>
              <label style={styles.label}>Last Name</label>

              <input
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                placeholder="Enter Last Name"
                style={styles.input}
              />

              {errors.lastName && <p style={styles.error}>{errors.lastName}</p>}
            </div>

            {/* CONTACT NUMBER */}

            <div style={styles.cardPurple}>
              <label style={styles.label}>Contact Number</label>

              <input
                name="contactNo"
                value={form.contactNo}
                onChange={handleChange}
                maxLength={10}
                placeholder="Enter Contact Number"
                style={{
                  ...styles.input,

                  border: checkingUser
                    ? "2px solid #2563eb"
                    : existingUserFound
                      ? "2px solid #16a34a"
                      : "1px solid #d1d5db",
                }}
              />

              {/* CHECKING */}

              {checkingUser && (
                <p
                  style={{
                    marginTop: "8px",
                    color: "#2563eb",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  🔍 Checking existing user...
                </p>
              )}

              {/* EXISTING USER */}

              {!checkingUser && existingUserFound && (
                <p
                  style={{
                    marginTop: "8px",
                    color: "#16a34a",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  ✓ {userSearchMessage}
                </p>
              )}

              {/* NEW USER */}

              {!checkingUser && !existingUserFound && userSearchMessage && (
                <p
                  style={{
                    marginTop: "8px",
                    color: "#64748b",
                    fontSize: "13px",
                    fontWeight: "600",
                  }}
                >
                  {userSearchMessage}
                </p>
              )}

              {errors.contactNo && (
                <p style={styles.error}>{errors.contactNo}</p>
              )}
            </div>

            {/* ALTERNATIVE CONTACT */}

            <div style={styles.cardOrange}>
              <label style={styles.label}>Alternative Contact</label>

              <input
                name="alternativeContactNo"
                value={form.alternativeContactNo}
                onChange={handleChange}
                maxLength={10}
                placeholder="Enter Alternative Contact"
                style={styles.input}
              />

              {errors.alternativeContactNo && (
                <p style={styles.error}>{errors.alternativeContactNo}</p>
              )}
            </div>

            {/* EMAIL */}

            <div style={styles.cardPink}>
              <label style={styles.label}>Email Address</label>

              <input
                name="emailId"
                value={form.emailId}
                onChange={handleChange}
                placeholder="Enter Email"
                style={styles.input}
              />

              {errors.emailId && <p style={styles.error}>{errors.emailId}</p>}
            </div>

            {/* PG NAME */}

            <div style={styles.cardSky}>
              <label style={styles.label}>PG Name</label>

              <input
                name="pgName"
                readOnly
                value={form.pgName || ""}
                style={styles.input}
              />
            </div>

            {/* AADHAAR */}

            <div style={styles.cardYellow}>
              <label style={styles.label}>Aadhaar Number</label>

              <input
                name="aadharCardNo"
                value={form.aadharCardNo}
                onChange={handleChange}
                maxLength={14}
                placeholder="1234 5678 9012"
                style={styles.input}
              />

              {errors.aadharCardNo && (
                <p style={styles.error}>{errors.aadharCardNo}</p>
              )}
            </div>

            {/* DOB */}

            <div style={styles.cardBlue}>
              <label style={styles.label}>Date Of Birth</label>

              <input
                name="userDateOfBirth"
                value={form.userDateOfBirth}
                onChange={handleChange}
                placeholder="DD-MM-YYYY"
                maxLength={10}
                style={styles.input}
              />

              {errors.userDateOfBirth && (
                <p style={styles.error}>{errors.userDateOfBirth}</p>
              )}
            </div>

            {/* GENDER */}

            <div style={styles.cardGreen}>
              <label style={styles.label}>Gender</label>

              <select
                name="gender"
                value={form.gender}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="">Select Gender</option>

                <option value="Male">Male</option>

                <option value="Female">Female</option>
              </select>

              {errors.gender && <p style={styles.error}>{errors.gender}</p>}
            </div>

            {/* JOINING DATE */}

            <div style={styles.cardOrange}>
              <label style={styles.label}>Joining Date</label>

              <input
                type="date"
                name="userjoiningDate"
                value={form.userjoiningDate}
                onChange={handleChange}
                min={today}
                style={styles.input}
              />

              {errors.userjoiningDate && (
                <p style={styles.error}>{errors.userjoiningDate}</p>
              )}
            </div>
          </div>
        </div>

        {/* ====================================================
                         SUBMIT
        ==================================================== */}

        <button
          style={{
            ...styles.submitBtn,

            ...(submitting ? styles.submitBtnDisabled : {}),
          }}
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Submitting..." : "Complete Booking"}
        </button>
      </div>
    </div>
  );
}

export default UserCompleteBookingForm;

/* ============================================================
                            STYLES
============================================================ */

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#eff6ff,#f8fafc,#e0f2fe)",
    padding: "30px",
    fontFamily: "Segoe UI, sans-serif",
  },

  container: {
    maxWidth: "1400px",
    margin: "0 auto",
  },

  title: {
    textAlign: "center",
    fontSize: "42px",
    fontWeight: "800",
    color: "#0f172a",
    marginBottom: "35px",
    letterSpacing: ".5px",
  },

  section: {
    background: "#fff",
    borderRadius: "22px",
    padding: "30px",
    marginBottom: "30px",
    boxShadow: "0 12px 30px rgba(0,0,0,.08)",
  },

  sectionTitle: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#1e293b",
    marginBottom: "25px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(270px,1fr))",
    gap: "22px",
    alignItems: "stretch",
  },

  label: {
    display: "block",
    marginBottom: "8px",
    color: "#1e293b",
    fontSize: "15px",
    fontWeight: "700",
  },

  input: {
    width: "100%",
    padding: "14px",
    border: "1px solid #d1d5db",
    borderRadius: "12px",
    outline: "none",
    background: "#fff",
    fontSize: "15px",
    fontWeight: "500",
    boxSizing: "border-box",
    transition: ".25s",
  },

  offerInput: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "12px",
    background: "#dcfce7",
    color: "#15803d",
    fontWeight: "800",
    fontSize: "18px",
    boxSizing: "border-box",
  },

  oldPrice: {
    fontSize: "18px",
    color: "#dc2626",
    fontWeight: "700",
    textDecoration: "line-through",
    marginBottom: "10px",
  },

  error: {
    marginTop: "8px",
    color: "#dc2626",
    fontSize: "13px",
    fontWeight: "700",
  },

  cardBlue: {
    background: "#dbeafe",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(37,99,235,.12)",
  },

  cardGreen: {
    background: "#dcfce7",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(34,197,94,.12)",
  },

  cardPurple: {
    background: "#ede9fe",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(124,58,237,.12)",
  },

  cardOrange: {
    background: "#ffedd5",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(249,115,22,.12)",
  },

  cardPink: {
    background: "#fce7f3",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(236,72,153,.12)",
  },

  cardSky: {
    background: "#e0f2fe",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(14,165,233,.12)",
  },

  cardYellow: {
    background: "#fef9c3",
    padding: "18px",
    borderRadius: "18px",
    transition: ".3s",
    boxShadow: "0 8px 18px rgba(234,179,8,.12)",
  },

  submitBtn: {
    width: "100%",
    padding: "18px",
    marginTop: "15px",
    border: "none",
    borderRadius: "16px",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
    transition: "all .3s ease",
    boxShadow: "0 10px 25px rgba(37,99,235,.30)",
  },

  submitBtnDisabled: {
    background: "#94a3b8",
    cursor: "not-allowed",
    boxShadow: "none",
  },

  /* ==========================================================
                              OTP
  ========================================================== */

  otpOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.65)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
    padding: "20px",
  },

  otpBox: {
    width: "100%",
    maxWidth: "430px",
    background: "#fff",
    borderRadius: "24px",
    padding: "35px",
    textAlign: "center",
    boxShadow: "0 25px 60px rgba(0,0,0,.3)",
  },

  otpIcon: {
    width: "75px",
    height: "75px",
    margin: "0 auto 18px",
    borderRadius: "50%",
    background: "#dbeafe",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "35px",
  },

  otpTitle: {
    fontSize: "26px",
    fontWeight: "800",
    color: "#0f172a",
    marginBottom: "10px",
  },

  otpText: {
    color: "#64748b",
    fontSize: "15px",
    lineHeight: "24px",
    marginBottom: "25px",
  },

  otpInput: {
    width: "100%",
    boxSizing: "border-box",
    padding: "16px",
    border: "2px solid #dbeafe",
    borderRadius: "12px",
    outline: "none",
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "800",
    letterSpacing: "8px",
    color: "#1e3a8a",
  },

  otpError: {
    color: "#dc2626",
    fontSize: "14px",
    fontWeight: "700",
    marginTop: "10px",
  },

  verifyOtpButton: {
    width: "100%",
    padding: "15px",
    marginTop: "20px",
    border: "none",
    borderRadius: "12px",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
  },

  verifyOtpButtonDisabled: {
    background: "#94a3b8",
    cursor: "not-allowed",
  },

  resendButton: {
    marginTop: "15px",
    border: "none",
    background: "transparent",
    color: "#2563eb",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
  },

  cancelButton: {
    display: "block",
    width: "100%",
    marginTop: "10px",
    padding: "10px",
    border: "none",
    background: "transparent",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};
